if not App.angularApp?
    return

# From https://docs.angularjs.org/api/ng/type/ngModel.NgModelController
App.angularApp.directive 'contenteditable', ['$sce', ($sce) ->
    return {
        restrict: 'A',
        require: '?ngModel', # get a hold of NgModelController
        link: (scope, element, attrs, ngModel) =>
            # do nothing if no ng-model
            if not ngModel
                return

            # Specify how UI should be updated
            ngModel.$render = () =>
                element.html($sce.getTrustedHtml(ngModel.$viewValue or ''))

                # make links clickable (not editable) and open in a new tab
                # TODO: make this optional?
                element.find('a').each (i, elem) ->
                    elem.contentEditable = 'false'
                    elem.target = '_blank'

            # Write data to the model
            read = () =>
                html = element.html()
                # When we clear the content editable the browser leaves a <br> behind
                # If strip-br attribute is provided then we strip this out
                if attrs.stripBr and html is '<br>'
                    html = ''

                ngModel.$setViewValue(html)

            # Listen for change events to enable binding
            element.on 'blur keyup change', () =>
                scope.$evalAsync(read)

            # Don't call read() to initialize the value from the view like in
            # the example because that would override the model value.
    }
]
